import React, { useState } from 'react';
import { Box, Button, Typography, alpha, useTheme } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../contexts/AuthContext';
import PaymentDialog from './PaymentDialog';

// Shown on every page once the certificate allowance is used up: the trial total, or the monthly plan total.
const LimitReachedBanner: React.FC = () => {
  const { subscription } = useAuth();
  const { palette } = useTheme();
  const t = palette.tokens;
  const [open, setOpen] = useState(false);

  const trial = subscription?.certificate_limit_kind === 'trial' && !subscription.trial_expired;
  const month = subscription?.certificate_limit_kind === 'month';
  if (!subscription?.certificate_limit_reached || !(trial || month)) return null;

  const resets = subscription.certificate_limit_resets_on
    ? new Date(subscription.certificate_limit_resets_on).toLocaleDateString(undefined, { day: 'numeric', month: 'long' })
    : 'next month';
  const text = trial
    ? `You have reached your limit of ${subscription.certificate_limit} certificates on the Trial plan. Buy a plan to continue.`
    : `You have reached your limit of ${subscription.certificate_limit} certificates this month. It resets on ${resets}.`;

  return (
    <>
      <Box
        role="region"
        aria-label="Certificate limit"
        sx={{
          display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', px: 3, py: 1.25,
          bgcolor: alpha(t.warning, 0.14), borderBottom: `1px solid ${alpha(t.warning, 0.4)}`,
        }}
      >
        <WarningAmberIcon aria-hidden sx={{ fontSize: 20, color: t.warning }} />
        <Typography sx={{ flex: '1 1 260px', fontSize: '14px', color: t.ink }}>{text}</Typography>
        {trial && (
          <Button variant="contained" size="small" onClick={() => setOpen(true)} sx={{ textTransform: 'none', fontWeight: 600, minHeight: 36 }}>
            Buy a plan
          </Button>
        )}
      </Box>
      <PaymentDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default LimitReachedBanner;
